import { fetchApi } from "./utils";

export const getAnalyticsByPageIDAndDate = async (PageID, endDate, interval) =>
  fetchApi(
    `/get-stats?PageID=${PageID}&EndDate=${endDate}&Interval=${interval}`,
    { method: "GET" }
  );
